{
  "validEmailsTitle": "Valid Emails/Domains",
  "newEmailPlaceholder": "New Email/Domain",
  "addButton": "Add",
  "emailToTestPlaceholder": "Email to test",
  "testButton": "Test",
  "testPassed": "Passed. This email will be allowed access.",
  "testFailed": "Failed. This email will not be allowed access.",
  "passwordWhitelistTitle": "Password Authentication Whitelist",
  "newEmailWhitelistPlaceholder": "New Email",
  "defaultReason": "Added via admin UI",
  "whitelistTestPassed": "Passed. This email can use password authentication.",
  "whitelistTestFailed": "Failed. This email must use Microsoft/Google login."
}
